import NoVideoDisplay from "Component/EmptyData/NoVideoDisplay";
import * as motion from "motion/react-client";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React, { useState } from "react";
import { Video } from "./Monitoring/Video";
import { Targeted } from "./Monitoring/Targeted";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { NoDisplayLive } from "Component/EmptyData/NoDisplayLive";
import { useDispatch, useSelector } from "react-redux";
import {
  realtimeCamera,
  realtimeSelected,
  realtimeSelectedCamera,
  realtimeSidebar,
} from "slice/realtimeSlice";
import { Videos } from "./Monitoring/Videos";
import {
  capitalizeFirstLetter,
  generateUUID,
  getStartStop,
  getUUIDFromLocalStorage,
  handleError,
  handleWarning,
  saveUUIDToLocalStorage,
} from "Helper";
import Detail from "./Monitoring/Detail";
import { falseData, trueData } from "./dummyData/targetData";
import { setUnsubscribed } from "slice/statusNatsSlice";
import { useRef } from "react";
import { useEffect } from "react";
import _ from "lodash";
import { subs, unsubscribeMessage } from "Config/natsClient";
import { LoadingLive } from "Component/LoadingModal/LoadingLive";
import { fetchApi } from "Config/fetchApi";
import {
  publishMessageBwc,
  subscribeToBwc,
  unsubscribeMessageBwc,
} from "Config/natsClientBWC";

export const RealTimeMonitoring = () => {
  const UUID = getUUIDFromLocalStorage();
  let conTrueData;
  let conFalseData;

  const dispatch = useDispatch();
  const [srcVideo, setSrcVideo] = useState(null);
  const realtime = useSelector((state) => state.realtime.value);
  const camera = useSelector((state) => state.realtime.selectedCamera);
  const { dataIpCamList, isLoadingIpCamList, errorIpCamList } = useSelector(
    (state) => state.ipCam.ipCamList
  );

  const previousDataRef = useRef(conTrueData);
  const [dpoModal, setDpoModal] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [receivedMessages, setReceivedMessages] = useState([]);
  const [statusBwc, setStatusBwc] = useState("");

  // console.log(getUuid, "getUuid");
  // console.log("%c" + getUuid + " uuid", "color: blue");
  const startBwc = async () => {
    setIsLoading(true);
    try {
      const response = await fetchApi().post(
        `/streaming-device/start-bwc-new`,
        {}
      );
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };
  useEffect(() => {
    if (statusBwc === "stop") {
      startBwc();
    }
  }, [statusBwc]);

  useEffect(() => {
    const uuid = generateUUID();
    saveUUIDToLocalStorage(uuid);
  }, []);

  // const uuid = 'maulana';

  const subject = "low";
  useEffect(() => {
    if (!UUID || UUID === "") return;
    // console.log(UUID, "UUIDUUID");

    const handleMessage = (msg) => {
      // console.log(msg, "natss");
      setReceivedMessages((prevMessages) => [...prevMessages, msg]);
    };

    // Subscribe to the topic
    subscribeToBwc(subject, handleMessage, UUID);

    // Unsubscribe setelah 1 detik jika komponen dibongkar
    // const timeoutId = setTimeout(() => {
    //   unsubscribeMessageBwc(subject, UUID);
    //   console.log(`Unsubscribed BWC: ${UUID}`);
    // }, 1000);

    // return () => {
    //   clearTimeout(timeoutId);
    //   unsubscribeMessageBwc(subject, UUID);
    // };
  }, [UUID]);

  useEffect(() => {
    if (!UUID || UUID === "") return;
    publishMessageBwc(subject, {
      text: {
        uuid: UUID,
        event: "start",
      },
    });
  }, [UUID]);

  useEffect(() => {
    fetchEvent(receivedMessages);
  }, [receivedMessages]);

  // console.log(receivedMessages, "receivedMessages");
  async function fetchEvent(getMessage) {
    const checkStartStop = await getStartStop(getMessage);
    localStorage.setItem("statusbwc", checkStartStop);
    const statusBwc = localStorage.getItem("statusbwc");
    setStatusBwc(statusBwc);
    // handleWarning(`Monitoring : ${checkStartStop}`);
  }

  useEffect(() => {
    const simplifiedDataTarget = conTrueData.map((item) => ({
      id: item?.nik,
      similarity: item?.confidenceScore,
    }));

    if (!_.isEqual(previousDataRef.current, simplifiedDataTarget)) {
      setDpoModal(conTrueData);
      previousDataRef.current = simplifiedDataTarget;
    } else {
      // console.log("Data has not changed");
    }
  }, [conTrueData]);

  if (camera?.status === "connected") {
    conFalseData = falseData;
    conTrueData = trueData;
  } else {
    conFalseData = [];
    conTrueData = [];
  }

  if (isLoadingIpCamList) {
    return (
      <div className="w-full overflow-hidden">
        {isLoadingIpCamList && <LoadingLive />}
      </div>
    );
  }

  if (dataIpCamList.length === 0) {
    return (
      <div className="">
        <NoDisplayLive />
      </div>
    );
  }

  return (
    <div className="">
      <div className="h-7">
        {!realtime === "" ? (
          <div className="">
            <NoDisplayLive />
          </div>
        ) : (
          <div>
            {!camera ? (
              <div className="flex justify-start items-center mb-2 text-mo-text">
                {/* <div onClick={handleBack}>
                  <Box
                    component="span"
                    sx={{
                      color: "text.white",
                      cursor: "pointer",
                      "&:hover": { color: "cyan" },
                    }}
                  >
                    <ArrowBackIosIcon fontSize="small" />
                  </Box>{" "}
                </div> */}
                <motion.div
                  initial={{ opacity: 0, x: -50 }} // Mulai dari kiri (-50px)
                  animate={{ opacity: 1, x: 0 }} // Bergerak ke posisi normal
                  transition={{
                    duration: 0.6, // Lebih cepat (0.6 detik)
                    ease: [0.33, 1, 0.68, 1], // Bezier untuk transisi smooth tapi cepat
                  }}
                  className="flex"
                >
                  <Typography variant="body1" component="h2">
                    <Box
                      className="font-bold"
                      component="span"
                      sx={{
                        color: "text.white",
                        // cursor: "pointer",
                        // "&:hover": { color: "cyan" },
                      }}
                    >
                      {dataIpCamList?.length} Kamera
                    </Box>{" "}
                    tersedia
                    {/* <Box
                      component="span"
                      className="font-bold"
                      sx={{
                        color: "text.white",
                        // cursor: "pointer",
                        // "&:hover": { color: "cyan" },
                      }}
                    >
                      {capitalizeFirstLetter(realtime?.jurisdiction_name)}
                    </Box> */}
                  </Typography>
                </motion.div>
              </div>
            ) : (
              <div className="flex justify-start items-center mb-2  text-mo-text">
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    // unsubscribeMessage("chat.general");
                    unsubscribeMessage(subs);
                    dispatch(setUnsubscribed());
                    dispatch(realtimeSelectedCamera(null));
                    dispatch(realtimeSelected(null));
                    // dispatch(clearTargetIsDpo([]));
                    // dispatch(clearTarget([]));
                  }}
                >
                  <ArrowBackIosIcon fontSize="small" />
                </div>
                <div className="flex items-center">
                  {/* Bagian kiri */}
                  {/* <Box
                    component="span"
                    sx={{
                      color: "text.white",
                    }}
                    className="bg-black z-99"
                  >
                    {capitalizeFirstLetter(realtime?.jurisdiction_name)}
                  </Box>
                  <div className="mx-1 bg-black z-99 relative"> / </div> */}
                  <motion.div
                    key={camera?.device_name}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                      duration: 0.6,
                      ease: [0.33, 1, 0.68, 1],
                    }}
                    className="flex"
                  >
                    <Box
                      component="span"
                      className="font-bold"
                      sx={{
                        color: "text.white",
                      }}
                    >
                      {camera?.device_name}
                    </Box>
                  </motion.div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <div>
        {!realtime ? (
          <div className="w-full flex flex-row  ">
            <div className="w-full  ">
              {camera === null ? (
                <Videos
                  dataIpCamList={dataIpCamList}
                  isLoadingIpCamList={isLoadingIpCamList}
                  srcVideo={srcVideo}
                  setSrcVideo={setSrcVideo}
                />
              ) : (
                <div className="flex flex-col lg:flex-row h-full gap-5 ">
                  {/* Bagian Kiri: Video + Detail */}
                  <div className="w-full lg:w-9/12 flex flex-col gap-5">
                    <div className="w-full">
                      <Video srcVideo={srcVideo} setSrcVideo={setSrcVideo} />
                    </div>
                    <div className="w-full">
                      <Detail trueData={conTrueData} falseData={conFalseData} />
                    </div>
                  </div>

                  {/* Bagian Kanan: Targeted */}
                  <div className="w-full lg:w-3/12 text-mo-text ">
                    <Targeted
                      trueData={conTrueData}
                      falseData={conFalseData}
                      camera={camera}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="">
            <NoDisplayLive />
          </div>
        )}
      </div>
    </div>
  );
};
